import { FpxBankElement } from '@stripe/react-stripe-js';
import type { StripeFpxBankElementChangeEvent } from '@stripe/stripe-js';
import { useTranslations } from '@vocab/react';
import { Box, IconInfo, Stack, Text } from 'braid-design-system';
import { useAtomValue } from 'jotai';

import translations from '../../../locales.vocab';
import { fpxInternetBankErrorAtom } from '../../../usecases/Fpx/FpxStore';

import { fpxWrapper, fpxWrapperFocus } from './fpx.css';

const ELEMENT_OPTIONS: any = {
  accountHolderType: 'individual',
  classes: {
    base: fpxWrapper,
    focus: fpxWrapperFocus,
  },
  style: {
    base: {
      padding: '10px 10px',
      color: '#595959',
      fontFamily:
        'Roboto, "Helvetica Neue", HelveticaNeue, Helvetica, Arial, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '14px',
      '::placeholder': {
        color: '#aab7c4',
      },
      width: 300,
    },
    invalid: {
      color: '#fa755a',
    },
  },
};

interface Props {
  onBankChange: (event: StripeFpxBankElementChangeEvent) => void;
}

const FpxComponent = ({ onBankChange }: Props) => {
  const { t } = useTranslations(translations);
  const errorMsg = useAtomValue(fpxInternetBankErrorAtom);

  return (
    <Box display="flex">
      <Box marginX="xsmall">
        <Text tone="info">
          <IconInfo tone="info" />
        </Text>
      </Box>
      <Box>
        <Stack space="medium">
          <Text tone="info">{t('pay.option.fpx.description')}</Text>
          <Box>
            <Text>{t('select.a.bank')}</Text>
            <div>
              <FpxBankElement
                id="fpx"
                options={ELEMENT_OPTIONS}
                onChange={onBankChange}
              />
            </div>
            {errorMsg !== '' && (
              <Box marginY="small">
                <Text tone="critical" size="small">
                  <IconInfo tone="critical" /> {errorMsg}
                </Text>
              </Box>
            )}
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};

export default FpxComponent;
